module.exports = __webpack_public_path__ + "static/media/optima-seguros-star.466e7c9d.svg";